import './index.css'

import Routes from "./Auth/Route";
import AuthProvider from "./Auth/AuthProvider";
import SessionProvider from "./Auth/SessionContext";
import "./Landingpage/ColorSchema.css"
import "./Landingpage/CommonVariables.css"
import {createTheme, ThemeProvider} from "@mui/material";
import {defaultColors} from "./Landingpage/ColorSchema";
import LandingPage from "./Landingpage/LandingPage";

export default function App() {
    const theme = createTheme({
        breakpoints:{
            values: {
                xs: 0,
                sm: 600,
                md: 1000,
                lg: 1200,
                xl: 1536,
            },
        },

        typography: {
            // set your global font stack
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            // override or add variants
            h1: {
                fontFamily: 'Roboto',
                fontWeight: 400,           // “Regular”
                fontSize: '36px',
                lineHeight: '44px',
                letterSpacing: '0px',
            },
            h2: {
                fontFamily: 'Roboto',
                fontWeight: 500,        // “Medium”
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '0.15px',
                color: defaultColors.primary
            },
            h3: {
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: '32px',
                lineHeight: '40px',
                letterSpacing: '0px',
            },

            // your custom “small” (Roboto Medium 14px / 20px lh / 0.1px ls)
            h4: {
                fontFamily: 'Roboto',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0.1px',
            },

        },
        palette: {
            primary: {main:defaultColors.primary},
            secondary: {main:defaultColors.secondary},

        },
    });

    return (
        <ThemeProvider theme={theme}>

            <LandingPage/>
        </ThemeProvider>

    )


}
